import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard } from 'lucide-react';
import { Button } from '../ui/button';

const SubscriptionsList = ({ subscriptions, text, formatDate, formatAmount }) => {
  const navigate = useNavigate();

  if (subscriptions.length === 0) {
    return (
      <div className="text-center py-12">
        <CreditCard className="w-16 h-16 text-[#E2E8F0] mx-auto mb-4" />
        <p className="text-[#546A76] mb-4">{text.noSubscriptions}</p>
        <Button
          onClick={() => navigate('/donate')}
          className="gold-btn rounded-full"
        >
          {text.setupSubscription}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {subscriptions.map((sub) => (
        <div 
          key={sub.id}
          data-testid={`subscription-item-${sub.id}`}
          className="p-6 rounded-xl border border-[#E2E8F0]"
        >
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-2xl font-bold text-[#1A252C]">
                {formatAmount(sub.amount)}
                <span className="text-sm font-normal text-[#546A76]"> / {text.monthly.toLowerCase()}</span>
              </p>
              <p className="text-sm text-[#546A76]">
                {text.nextPayment}: {formatDate(sub.next_payment_date)}
              </p>
            </div>
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${
              sub.status === 'active' 
                ? 'bg-green-100 text-green-700'
                : sub.status === 'paused'
                ? 'bg-amber-100 text-amber-700'
                : 'bg-red-100 text-red-700'
            }`}>
              {sub.status}
            </span>
          </div>
          <div className="flex gap-2">
            {sub.status === 'active' && (
              <Button size="sm" variant="outline" className="rounded-full">
                {text.pauseSubscription}
              </Button>
            )}
            {sub.status === 'paused' && (
              <Button size="sm" className="primary-btn rounded-full">
                {text.resumeSubscription}
              </Button>
            )}
            {sub.status !== 'cancelled' && (
              <Button size="sm" variant="outline" className="rounded-full text-red-600 border-red-200">
                {text.cancelSubscription}
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubscriptionsList;
